import React from "react"

import Theme from "./src/styles/Theme"
import Layout from "./src/components/Layout"

export const wrapPageElement = ({ element, props }) => (
  <Layout {...props}>{element}</Layout>
)
export const wrapRootElement = ({ element }) => <Theme>{element}</Theme>
